import { useAuth } from '@nvision/identity-core';

export const useIdentityAuth = () => {
  return useAuth();
};
